import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';

/**
 * 设置-模块
 */
var setting = {
  path: '/setting',
  redirect: '/setting/index',
  component: RootLayout,
  children: [{
    path: 'index',
    name: 'Setting',
    component: function component() {
      return import('views/setting/Setting');
    },
    meta: {
      title: '设置中心'
    }
  }, {
    path: 'account/security',
    name: 'AccountSecurity',
    component: function component() {
      return import('views/setting/accountSecurity.vue');
    },
    meta: {
      title: '账号安全',
      auth: true
    }
  }, {
    path: 'resetTranpwd',
    name: 'ResetTranpwd',
    component: function component() {
      return import('views/setting/ResetTranpwd');
    },
    meta: {
      title: '交易密码设置'
    }
  }, {
    path: 'about',
    name: 'About',
    component: function component() {
      return import('views/setting/About');
    },
    meta: {
      title: '联系我们'
    }
  }, {
    path: '/setting/license',
    name: 'License',
    component: function component() {
      return import('views/setting/license');
    },
    meta: {
      title: '资质证照'
    }
  }, {
    path: '/setting/license/business',
    name: 'LicenseBusiness',
    component: function component() {
      return import('views/setting/license/business');
    },
    meta: {
      title: '营业执照'
    }
  }, {
    path: '/setting/license/artwork',
    name: 'LicenseArtwork',
    component: function component() {
      return import('views/setting/license/artwork');
    },
    meta: {
      title: '艺术品经营单位备案证明'
    }
  }, {
    path: '/setting/license/information',
    name: 'LicenseInformation',
    component: function component() {
      return import('views/setting/license/information');
    },
    meta: {
      title: '信息系统安全等级保护备案证明'
    }
  }, {
    path: '/setting/license/telecom',
    name: 'LicenseTelecom',
    component: function component() {
      return import('views/setting/license/telecom');
    },
    meta: {
      title: '增值电信业务经营许可证'
    }
  }, {
    path: '/setting/license/blockchain',
    name: 'LicenseBlockchain',
    component: function component() {
      return import('views/setting/license/blockchain');
    },
    meta: {
      title: '区块链信息服务备案'
    }
  }, {
    path: 'registerProtocol',
    // 用户协议
    name: 'RegisterProtocolPage',
    meta: {
      title: '用户协议'
    },
    component: function component() {
      return import('views/setting/protocol/Register');
    }
  }, {
    path: 'privacyProtocol',
    // 隐私政策
    name: 'PrivacyProtocolPage',
    meta: {
      title: '隐私政策'
    },
    component: function component() {
      return import('views/setting/protocol/Privacy');
    }
  }, {
    path: 'permissions',
    name: 'Permissions',
    component: function component() {
      return import('views/setting/permissions');
    },
    meta: {
      title: '启用权限说明'
    }
  }, {
    path: 'sdk',
    name: 'Sdk',
    component: function component() {
      return import('views/setting/sdk');
    },
    meta: {
      title: '第三方sdk使用说明'
    }
  }, {
    path: '/themeColor',
    name: 'ThemeColor',
    component: function component() {
      return import('views/setting/ThemeColor');
    },
    meta: {
      title: '外观设置'
    }
  }]
};
export default setting;